// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: ueTFx13x7Is
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import SelectCountry from "../../SelectCountry"; // plasmic-import: DRLS9kjJ501/component
import SelectBusinessType from "../../SelectBusinessType"; // plasmic-import: 4omYklaUsMs/component
import SelectBusinessType__Option from "../../SelectBusinessType__Option"; // plasmic-import: ZzWMn50I_m-/component
import SelectBizStructure from "../../SelectBizStructure"; // plasmic-import: g-S2CDsrTzx/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicNewOnboardingPage.module.css"; // plasmic-import: ueTFx13x7Is/css
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicNewOnboardingPage__VariantProps = new Array();

export const PlasmicNewOnboardingPage__ArgProps = new Array();

const $$ = {};

function PlasmicNewOnboardingPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "selectCountry.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "selectBusinessType.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "selectBusinessStructure.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__zJu5)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__jyNaL
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__fhNjn)}>
            <div className={classNames(projectcss.all, sty.freeBox__wuMLf)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__t5FAz)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__tNO)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__mmJ6B)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__hnH04)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__gHyLl)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__k4JoS)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__x6KG)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__oove5
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__fuFiV
                )}
              >
                {"Account Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__d2Clb
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___2T5M1
                )}
              >
                {"Review & Submit"}
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__cJ4Fa)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___48Ie3
                )}
              >
                {"Country"}
              </div>
              <SelectCountry
                data-plasmic-name={"selectCountry"}
                data-plasmic-override={overrides.selectCountry}
                className={classNames("__wab_instance", sty.selectCountry)}
                onChange={(...eventArgs) => {
                  p.generateStateOnChangeProp($state, [
                    "selectCountry",
                    "value"
                  ])(eventArgs[0]);
                }}
                value={p.generateStateValueProp($state, [
                  "selectCountry",
                  "value"
                ])}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__nLxnb
                )}
              >
                {"Type of Business"}
              </div>
              <SelectBusinessType
                data-plasmic-name={"selectBusinessType"}
                data-plasmic-override={overrides.selectBusinessType}
                className={classNames("__wab_instance", sty.selectBusinessType)}
                onChange={(...eventArgs) => {
                  p.generateStateOnChangeProp($state, [
                    "selectBusinessType",
                    "value"
                  ])(eventArgs[0]);
                }}
                value={p.generateStateValueProp($state, [
                  "selectBusinessType",
                  "value"
                ])}
              >
                <SelectBusinessType__Option
                  className={classNames("__wab_instance", sty.option__lUzlb)}
                  value={"individual"}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___5JaPd
                    )}
                  >
                    {"Individual"}
                  </div>
                </SelectBusinessType__Option>
                <SelectBusinessType__Option
                  className={classNames("__wab_instance", sty.option__uR4Oq)}
                  value={"company"}
                >
                  {"Company"}
                </SelectBusinessType__Option>
              </SelectBusinessType>
              <div
                data-plasmic-name={"businessStructText"}
                data-plasmic-override={overrides.businessStructText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.businessStructText
                )}
              >
                {"Business Structure"}
              </div>
              <SelectBizStructure
                data-plasmic-name={"selectBusinessStructure"}
                data-plasmic-override={overrides.selectBusinessStructure}
                className={classNames(
                  "__wab_instance",
                  sty.selectBusinessStructure
                )}
                onChange={(...eventArgs) => {
                  p.generateStateOnChangeProp($state, [
                    "selectBusinessStructure",
                    "value"
                  ])(eventArgs[0]);
                }}
                value={p.generateStateValueProp($state, [
                  "selectBusinessStructure",
                  "value"
                ])}
              />

              <div
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames(projectcss.all, sty.continueButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lUuvw
                  )}
                >
                  {"Continue"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "selectCountry",
    "selectBusinessType",
    "businessStructText",
    "selectBusinessStructure",
    "continueButton"
  ],

  lineStack: ["lineStack", "circle", "circle2", "circle3", "circle4"],
  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  selectCountry: ["selectCountry"],
  selectBusinessType: ["selectBusinessType"],
  businessStructText: ["businessStructText"],
  selectBusinessStructure: ["selectBusinessStructure"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewOnboardingPage__ArgProps,
          internalVariantPropNames: PlasmicNewOnboardingPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNewOnboardingPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNewOnboardingPage";
  } else {
    func.displayName = `PlasmicNewOnboardingPage.${nodeName}`;
  }
  return func;
}

export const PlasmicNewOnboardingPage = Object.assign(
  // Top-level PlasmicNewOnboardingPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    selectCountry: makeNodeComponent("selectCountry"),
    selectBusinessType: makeNodeComponent("selectBusinessType"),
    businessStructText: makeNodeComponent("businessStructText"),
    selectBusinessStructure: makeNodeComponent("selectBusinessStructure"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicNewOnboardingPage
    internalVariantProps: PlasmicNewOnboardingPage__VariantProps,
    internalArgProps: PlasmicNewOnboardingPage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicNewOnboardingPage;
/* prettier-ignore-end */
